// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2CB1_","footer":"ModalCreateQualiphyProcedure_footer__wsh1h","additionData":"ModalCreateQualiphyProcedure_additionData__3_9fL"};